<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    en: {
    },
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout
  },
  data() {
    return {
      orders: null,
    };
  },
  methods: {
    getOrders() {
      this.orders = null;

      api
        .get("events/orders")
        .then((response) => {
          if (response.data.status == "success") {
            this.orders = response.data.list;
          }
        })
        .catch((error) => {
          if (error) {
            this.orders = [];
          }
        })
    },
  },
  mounted() {
    this.getOrders();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/events">Eventos</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Minhas Compras</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Minhas Compras</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!orders">
          <b-spinner variant="primary" role="status"></b-spinner>
        </div>

        <div v-else-if="orders && orders.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Data</th>
                <th>Evento</th>
                <th>Quantidade</th>
                <th>Valor</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in orders" :key="row.index">
                <td>{{ row.id }}</td>
                <td>{{ row.date }}</td>
                <td>{{ row.event }}</td>
                <td>{{ row.qty }}</td>
                <td>{{ row.value | currency }}</td>
                <td>
                  <span v-if="row.status == 'pending'" class="badge badge-soft-default font-size-13 text-uppercase">Pendente</span>
                  <span v-else-if="row.status == 'approved'" class="badge badge-soft-success font-size-13 text-uppercase">Aprovado</span>
                  <span v-else-if="row.status == 'canceled'" class="badge badge-soft-danger font-size-13 text-uppercase">Cancelado</span>
                </td>
                <td class="text-right">
                  <router-link :to="'/events/orders/' + row.id" class="btn btn-default btn-sm btn-rounded font-size-14">
                    Ver
                    <i class="mdi mdi-arrow-right ml-1"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>